import { render, staticRenderFns } from "./ReportAffDetail.vue?vue&type=template&id=6a1adc40&"
import script from "./ReportAffDetail.vue?vue&type=script&lang=js&"
export * from "./ReportAffDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports